import { useContext } from 'react'
import { LabelContext } from './LabelContextDef'

export function useLabelContext() {
  const context = useContext(LabelContext)
  if (context === undefined) {
    throw new Error('useLabelContext must be used within a LabelProvider')
  }
  return context
}
